import { render } from "./BioTv.vue?vue&type=template&id=7dffc278"
import script from "./BioTv.vue?vue&type=script&lang=js"
export * from "./BioTv.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Project Coustomer\\vue film\\film\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__